import { lazy } from 'react';

// Types
import { StripePaymentProviderProps } from './StripePaymentProvider.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "stripePaymentProvider" */ './StripePaymentProvider')),
);

const LazyComponentWithSuspense = withSuspense<StripePaymentProviderProps>(LazyComponent, 'StripePaymentProvider');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as StripePaymentProvider };
